import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import type {
  ProtectedImageProps} from 'src/app/forms/ProtectedImage';
import {
  ProtectedImage
} from 'src/app/forms/ProtectedImage';
import type {IFormFieldV2} from 'src/types/FormV2';

export interface FormReferenceImageProps
  extends Omit<ProtectedImageProps, 'src'> {
  field: IFormFieldV2;
}

/**
 * FormReferenceImage component that handles rendering reference images for form fields.
 * Automatically checks if the field has a reference image and renders it with consistent styling.
 */
export const FormReferenceImage = React.memo<FormReferenceImageProps>(
  ({field, ...props}) => {
    // Check if field has a reference image
    const hasReferenceImage = !!field.builderOptions?.referenceImageUrl;

    if (!hasReferenceImage || !field.builderOptions?.referenceImageUrl) {
      return null;
    }

    return (
      <Stack gap="xs">
        <Text size="xs" c="dimmed">
          Reference Image for {field.label}
        </Text>
        <ProtectedImage
          src={field.builderOptions.referenceImageUrl}
          alt="Reference image"
          fit="contain" // prevents cropping when constrained
          maw="100%" // wrapper cannot exceed parent width
          mah="700px" // wrapper cannot exceed 700px height
          style={{
            width: 'auto', // keep intrinsic width
            height: 'auto', // keep intrinsic height
            maxWidth: '100%', // but never wider than parent
            maxHeight: '700px', // and never taller than 700px
            display: 'block', // removes inline-image baseline gap
          }}
          radius="sm"
          {...props}
        />
      </Stack>
    );
  }
);
